import api from '../libs/axios';

export const getNewsList = async (params, signal) => {
  const response = await api.get('/news', { params, signal });
  return response.data;
};
